import { render } from "./LicensePageTabViewServices.vue?vue&type=template&id=18b484e0&ts=true"
import script from "./LicensePageTabViewServices.vue?vue&type=script&lang=ts"
export * from "./LicensePageTabViewServices.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__